import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { ProtocolCodeField } from '@lib/protocols/data-access';
import { TranslatePipe } from '@ngx-translate/core';

import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'protocols-removable-code-list',
  standalone: true,
  imports: [MatIcon, TranslatePipe],
  templateUrl: './removable-code-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RemovableCodeListComponent {
  readonly items = input.required<ProtocolCodeField[]>();
  readonly removeItem = output<number>();
}
